/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_FontInputs */

const en_read_along_font = /** @type {(inputs: Read_Along_FontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Font`)
};

const es_read_along_font = /** @type {(inputs: Read_Along_FontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuente`)
};

/**
* | output |
* | --- |
* | "Font" |
*
* @param {Read_Along_FontInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_font = /** @type {((inputs?: Read_Along_FontInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_FontInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_font(inputs)
	return en_read_along_font(inputs)
});